import React, { useRef, useState, useEffect } from 'react'

import s from './HorizontalScroll.module.css'

interface HorizontalScrollProps {
  children: React.ReactNode
  className?: string
}

export const HorizontalScroll: React.FC<HorizontalScrollProps> = ({
  children,
  className = '',
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [showLeftFade, setShowLeftFade] = useState(false)
  const [showRightFade, setShowRightFade] = useState(false)

  const handleScroll = () => {
    const el = containerRef.current
    if (!el) return

    setShowLeftFade(el.scrollLeft > 0)
    setShowRightFade(el.scrollLeft + el.clientWidth < el.scrollWidth - 1)
  }

  useEffect(() => {
    const el = containerRef.current

    if (!el) return

    handleScroll()

    el.addEventListener('scroll', handleScroll)

    return () => el.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={`${s.wrapper} ${className}`}>
      {showLeftFade && <div className={`${s.fade} ${s.left}`} />}
      {showRightFade && <div className={`${s.fade} ${s.right}`} />}

      <div ref={containerRef} className={s.scrollContainer}>
        {children}
      </div>
    </div>
  )
}
